<template>
  <div class="container float-page">
    <!-- Float Box -->
    <div class="float-box">
      <!-- Float Card Body -->
      <div class="card">
        <div class="card-body float-card-body">
          <h1 class="mb-4"> {{ $t('Customer.customerRegist.register') }}</h1>

          <el-form
            :model="registerModel"
            ref="registerForm"
            :rules="registerRules"
          >
            <el-form-item prop="customerEmail">
              <el-input
                :readonly="true"
                v-model="registerModel.customerEmail"
                :placeholder="$t('Customer.customerRegist.mailbox')"
                suffix-icon="fas fa-envelope fa-sm"
                :disabled="true"
              ></el-input>
            </el-form-item>
            <el-form-item prop="customerName">
              <el-input
                suffix-icon="fas fa-user fa-sm"
                v-model="registerModel.customerName"
                :placeholder="$t('Customer.customerRegist.customerName')"
              ></el-input>
            </el-form-item>
            <el-form-item prop="customerPwd">
              <el-input
                suffix-icon="fas fa-lock fa-sm"
                show-password
                v-model="registerModel.customerPwd"
                :placeholder="$t('Customer.customerRegist.customerPwd')"
              ></el-input>
            </el-form-item>
            <el-form-item prop="customerRePwd">
              <el-input
                show-password
                suffix-icon="fas fa-lock fa-sm"
                v-model="registerModel.customerRePwd"
                :placeholder="$t('Customer.customerRegist.customerRePwd')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('Customer.customerRegist.sex')">
              <el-radio label="Male" v-model="registerModel.customerSex"
                > {{ $t('Customer.customerRegist.Male') }}</el-radio
              >
              <el-radio label="Female" v-model="registerModel.customerSex"
                > {{ $t('Customer.customerRegist.Female') }}</el-radio
              >
            </el-form-item>
            <el-form-item :label="$t('Customer.customerRegist.customerBirth')">
              <el-date-picker
                v-model="registerModel.customerBirth"
                type="date"
                :placeholder="$t('Customer.customerRegist.checkDate')"
              ></el-date-picker>
            </el-form-item>
            <el-form-item :label="$t('Customer.customerRegist.customerArea')">
              <el-select v-model="registerModel.customerArea">
                <el-option value="臺灣 - 臺北市">{{$t('Customer.customerRegist.t1')}}</el-option>
                <el-option value="臺灣 - 新北市">{{$t('Customer.customerRegist.t2')}}</el-option>
                <el-option value="臺灣 - 桃園市">{{$t('Customer.customerRegist.t3')}}</el-option>
                <el-option value="臺灣 - 臺中市">{{$t('Customer.customerRegist.t4')}}</el-option>
                <el-option value="臺灣 - 臺南市">{{$t('Customer.customerRegist.t5')}}</el-option>
                <el-option value="臺灣 - 高雄市">{{$t('Customer.customerRegist.t6')}}</el-option>
                <el-option value="臺灣 - 基隆市">{{$t('Customer.customerRegist.t7')}}</el-option>
                <el-option value="臺灣 - 新竹市">{{$t('Customer.customerRegist.t8')}}</el-option>
                <el-option value="臺灣 - 嘉義市">{{$t('Customer.customerRegist.t9')}}</el-option>
                <el-option value="臺灣 - 新竹縣">{{$t('Customer.customerRegist.t10')}}</el-option>
                <el-option value="臺灣 - 苗栗縣">{{$t('Customer.customerRegist.t11')}}</el-option>
                <el-option value="臺灣 - 彰化縣">{{$t('Customer.customerRegist.t12')}}</el-option>
                <el-option value="臺灣 - 南投縣">{{$t('Customer.customerRegist.t13')}}</el-option>
                <el-option value="臺灣 - 雲林縣">{{$t('Customer.customerRegist.t14')}}</el-option>
                <el-option value="臺灣 - 嘉義縣">{{$t('Customer.customerRegist.t15')}}</el-option>
                <el-option value="臺灣 - 屏東縣">{{$t('Customer.customerRegist.t16')}}</el-option>
                <el-option value="臺灣 - 宜蘭縣">{{$t('Customer.customerRegist.t17')}}</el-option>
                <el-option value="臺灣 - 花蓮縣">{{$t('Customer.customerRegist.t18')}}</el-option>
                <el-option value="臺灣 - 臺東縣">{{$t('Customer.customerRegist.t19')}}</el-option>
                <el-option value="臺灣 - 澎湖縣">{{$t('Customer.customerRegist.t20')}}</el-option>
                <el-option value="香港特別行政區">{{$t('Customer.customerRegist.t21')}}</el-option>
                <el-option value="澳門特別行政區">{{$t('Customer.customerRegist.t22')}}</el-option>
                <el-option value="中國大陸">{{$t('Customer.customerRegist.t23')}}</el-option>
                <el-option value="海外地區">{{$t('Customer.customerRegist.t24')}}</el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <div class="divCheck">
                <input
                  type="checkbox"
                  v-model.lazy="registerModel.customerrecepter"
                  id="customerrecepter"
                />
                <label for="customerrecepter"
                  > {{ $t('Customer.customerRegist.Soonnet') }}</label
                >
              </div>

              <!-- <el-checkbox v-model="registerModel.customerrecepter">
                <span class="all_label"
                  >我願意接收 尋寶網 Soonnet的最新資訊</span
                >
              </el-checkbox> -->
            </el-form-item>
            <el-form-item>
              <div class="divCheck">
                <input
                  type="checkbox"
                  v-model.lazy="registerModel.customerpolicy"
                  id="customerpolicy"
                />
                <label for="customerpolicy">
                  {{ $t('Customer.customerRegist.agreed') }}<a
                    href="https://www.soonnet.org/service"
                    target="_blank"
                    >{{ $t('Customer.customerRegist.service') }}</a
                  >、<a href="https://www.soonnet.org/privacy" target="_blank"
                    >{{ $t('Customer.customerRegist.policy') }}</a
                  > {{ $t('Customer.customerRegist.ors') }} <a href="https://www.soonnet.org/copyright" target="_blank"
                    >{{ $t('Customer.customerRegist.clause') }}</a
                  >
                </label>
              </div>
              <!-- <el-checkbox v-model="registerModel.customerpolicy">
                <label for="agreement" class="all_label"
                  >我已閱讀及同意<a
                    href="https://www.soonnet.org/service"
                    target="_blank"
                    >服務條款</a
                  >、<a href="https://www.soonnet.org/privacy" target="_blank"
                    >私隱條款</a
                  >及<a href="https://www.soonnet.org/copyright" target="_blank"
                    >著作權條款</a
                  >
                </label></el-checkbox
              > -->
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                :disabled="submitBtn"
                class="btn btn-block btn-primary btn-lg mt-3"
                @click="submitForm('registerForm')"
              >
              {{ $t('Customer.customerRegist.register') }}
              </el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <!-- /.float-card-body -->
    </div>
    <!-- /.float box -->
  </div>
</template>
<script>
import { Message } from "element-ui";
export default {
  data() {
    /* 是否邮箱*/
    var isEmail = (rule, value, callback) => {
      const reg = /^([a-zA-Z0-9]+[-_\.]?)+@[a-zA-Z0-9]+\.[a-z]+$/;
      if (value == "" || value == undefined || value == null) {
        return callback(new Error(this.$t('Customer.customerRegist.registerRules.customerEmail.error1')));
      } else {
        if (value.indexOf("@") === -1) {
          callback(new Error(this.$t('Customer.customerRegist.registerRules.customerEmail.error2')));
        } else {
          callback();
        }
      }
    };
    var checkPass = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('Customer.customerRegist.registerRules.customerRePwd.error1')));
      } else if (value !== this.registerModel.customerPwd) {
        return callback(new Error(this.$t('Customer.customerRegist.registerRules.customerRePwd.error2')));
      } else {
        callback();
      }
    };
    return {
      submitBtn: true,
      registerModel: {
        customerEmail: null,
        customerName: null,
        customerPwd: null,
        customerRePwd: null,
        customerSex: null,
        customerBirth: null,
        customerArea: null,
        customerpolicy: false,
        customerrecepter: false,
      },
      registerRules: {
        customerEmail: [
          {
            validator: isEmail,
            trigger: "blur",
          },
        ],
        customerName: {
          required: true,
          message: this.$t('Customer.customerRegist.registerRules.customerName'),
          trigger: "blur",
        },
        customerPwd: {
          required: true,
          message: this.$t('Customer.customerRegist.registerRules.customerPwd'),
          min: 6,
          trigger: "blur",
        },
        customerRePwd: {
          required: true,
          validator: checkPass,
          trigger: "blur",
        },
      },
    };
  },
  watch: {
    "registerModel.customerpolicy": {
      handler: function (newvalue, oldvalue) {
        if (newvalue) {
          this.submitBtn = false;
        } else {
          this.submitBtn = true;
        }
      },
    },
     '$i18n.locale': function () {
      this.setregisterRules();
    },
    // "registerModel.customerrecepter": {
    //   handler: function (newvalue, oldvalue) {
    //     if (newvalue && this.registerModel.customerpolicy) {
    //       this.submitBtn = false;
    //     } else {
    //       this.submitBtn = true;
    //     }
    //   },
    // },
  },
  created() {
    this.$store.dispatch("updateCurrentIndex", 0);
    this.registerModel.customerEmail = this.$route.query.email;
  },
  methods: {
    setregisterRules(){
       this.registerRules.customerName.message = this.$t('Customer.customerRegist.registerRules.customerName');
       this.registerRules.customerPwd.message = this.$t('Customer.customerRegist.registerRules.customerPwd');
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (
            this.registerModel.customerPwd == this.registerModel.customerRePwd
          ) {
            //請求
            let params = {
              sgL_UsersName: this.registerModel.customerName,
              sgL_LoginPassword: this.registerModel.customerPwd,
              sgL_LoginEmail: this.registerModel.customerEmail,
              sgL_Sex:
                this.registerModel.customerSex == null ||
                this.registerModel.customerSex == ""
                  ? "Unknown"
                  : this.registerModel.customerSex,
              sgL_Birth: this.registerModel.customerBirth,
              sgL_Area: this.registerModel.customerArea,
              isMessage: this.registerModel.customerrecepter,
            };
            console.log(params);
            this.$api.common.CustomerRegister(params).then((res) => {
              if (res.data.success) {
                //跳轉頁面
                this.$router.push({ name: "registerSuccess" });
              } else {
                Message({
                  type: "error",
                  message: res.data.error.message,
                });
              }
            });
          } else {
            Message({
              type: "error",
              message: "密碼輸入不一致",
            });
          }
        } else {
          Message({
            type: "error",
            message: "未能成功註冊，請檢查所有必填欄位",
          });
        }
      });
    },
  },
};
</script>
<style scoped>
/* .el-checkbox__input {
  vertical-align: text-top;
} */
/* .all_label {
  word-break: normal;
  display: inline-table;
  white-space: pre-line;
  word-wrap: break-word;
  overflow: hidden;
  line-height: 20px;
} */
/* .el-form {
  background-color: gainsboro;
} */
.divCheck {
  line-height: 1.5;
  font-size: 14px;
  font-weight: 400;
  font-style: normal;
  word-wrap: break-word;
  word-break: break-all;
}
label {
  display: inline;
}
</style>


// WEBPACK FOOTER //
// src/components/Customer/customerRegist.vue